export const money = (value) =>
  /^(0(,|\.)[0-9]{1,2}|[1-9][0-9]{0,15}((,|\.)[0-9]{1,2})?)$/.test(value);
